// Efeitos das notificações do KANBAN / contrato de card.
// Registrado em `constants/notificationHandlers.ts`.

import type {
  DestinoDeNotificacao,
  NotificacaoParaDestino,
} from '../../constants/notificationHandlers';

/**
 * O que o KANBAN le' da mensagem que chega pelo WebSocket.
 *
 * Mora aqui, e nao no `hooks/useNotificacoes`: quem le' o campo e' quem sabe a
 * forma dele. O registry compoe os tipos dos dominios num so' — ver
 * `DadosWsDeNotificacao`. Os efeitos do kanban (`contrato_gerado`,
 * `contrato_campos_pendentes`) eram do gerador antigo de contrato de evento e
 * sairam com ele; sobrou o destino do clique.
 */
export interface DadosWsKanban {
  card_id?: number;
  card_titulo?: string;
  projeto_id?: number;
  dias_restantes?: number;
  evento_id?: number;
}

/** O que o KANBAN le' do `dados_json` PERSISTIDO (o que o painel lista). */
export interface DadosJsonKanban {
  card_id?: number;
  card_titulo?: string;
  projeto_id?: number;
  projeto_titulo?: string;
  dias_restantes?: number;
}

/**
 * Destino do clique: notificação de card/projeto abre o kanban.
 *
 * ⚠️ Reivindica pela FORMA do payload, não pelo tipo — `projeto_id` presente
 * basta. É como sempre funcionou, e enumerar tipos aqui deixaria de fora os
 * que o backend viesse a criar (`card_comment`, `card_deadline_overdue`, ...),
 * que parariam de navegar sem ninguém notar.
 *
 * Tem PRECEDÊNCIA sobre os outros domínios (ver `DESTINOS` no registry): uma
 * notificação com `projeto_id` abre o kanban mesmo trazendo `contrato_id`.
 */
// ⚠️ `function` nomeada, e não arrow atribuída a const: o plugin react do
// eslint trata arrow-com-destructuring como componente e cobra PropTypes de
// cada propriedade. Isto é função pura de dado, sem JSX no arquivo inteiro.
function destinoKanban({ dados_json: dados }: NotificacaoParaDestino): string | null {
  const projetoId = dados?.projeto_id;
  if (!projetoId) return null;
  const cardId = dados?.card_id;
  return `/kanban?projeto=${projetoId}${cardId ? `&card=${cardId}` : ''}`;
}

export const DESTINO_KANBAN: DestinoDeNotificacao = destinoKanban;
